import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

/**
 * Toast — thin wrapper over react-toastify (donor dependency). Mount
 * <ToastHost/> once near the app root; call the helpers anywhere.
 */
export function ToastHost() {
  return (
    <ToastContainer
      position="top-right"
      autoClose={4000}
      hideProgressBar
      newestOnTop
      theme="light"
    />
  );
}

export const notify = {
  success: (msg: string) => toast.success(msg),
  error: (msg: string) => toast.error(msg),
  info: (msg: string) => toast.info(msg),
};
